import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { useDiskStore } from '../../store/storeDisk'

const validationSchema = yup.object({
    name: yup
        .string()
        .trim()
        .matches(/^[^~!@\/:\\#$%^&*=|`"<>]*$/, 'Название не должно содержать символы ~!@/:#$%^&*=|`\"<>')
        .max(100, 'Название может быть не более 100 символов')
        .required('Название обязательное'),
})

export const FolderCreateDialog = ({ open, handleClose, folder }) => {
    const { createFolder, isLoadingCreateFolder } = useDiskStore((state) => state)

    const formik = useFormik({
        initialValues: {
            name: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            await createFolder({ name: folder ? `/${folder}/${values.name}/` : values.name })
            handleClose()
        },
    })

    return (
        <>
            <Dialog
                PaperProps={{
                    style: {
                        width: '500px',
                    },
                }}
                open={open}
                onClose={handleClose}>
                <DialogTitle>Создать папку</DialogTitle>

                <form onSubmit={formik.handleSubmit}>
                    <DialogContent>
                        <TextField
                            fullWidth
                            id="name"
                            name="name"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.name && Boolean(formik.errors.name)}
                            helperText={formik.touched.name && formik.errors.name}
                            variant="outlined"
                            label="Название"
                        />
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleClose} variant="outlined">
                            Отменить
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={!(formik.isValid && formik.dirty) || isLoadingCreateFolder}>
                            Создать
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    )
}
